import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Toast } from 'vant'

const whiteList = ['/login', '/wechat'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (store.getters.token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store.getters.name.length === 0) {
        store
          .dispatch('GetInfo')
          .then(() => {
            // 已经拉取用户信息和menu
            next()
          })
          .catch(() => {
            store.dispatch('LogOut').then(() => {
              Toast.fail('验证失败,请重新登录')
            })
            next({ path: '/login' })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else if (to.path.substring(0, 10) == '/write-off') {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
